import React from 'react'
import ReactApexChart from 'react-apexcharts'
import { Col, Row } from 'reactstrap'
import { beyoLineChart } from '../../../Data/Dashboard/Default'
import { Badges, H2, H3, H4, Image, LI, P, UL } from '../../../AbstractElements'
import { dynamicImage, dynamicNumber } from '../../../Utils'

export default function BeyoDetails() {
    return (
        <Col xxl="5" xl="8" md="6" className="box-col-7">
            <Row className="beyo-line">
                <div className="beyoline-header bg-light-primary">
                    <div id="beyo-line">
                    <ReactApexChart
                        options={beyoLineChart}
                        series={beyoLineChart.series}
                        type="bar"
                        height={280}
                    />
                    </div>
                </div>
                <div className="beyo-detail">
                    <H4>{'Exploring Boundaries '}
                        <Badges color='primary'>{'4 hours ago'}</Badges>
                    </H4>
                    <P>{"One of the world's most finest, young surf srars, Kanoa lgarashi."}</P>
                    <div className="date-history">
                        <UL className='simple-list flex-row'>
                            {dynamicNumber(4).map((item, index) => (
                                <LI key={index}>
                                    <Image className="img-fluid" src={dynamicImage(`dashboard/beyond-line/${item}.png`)} alt="" />
                                </LI>
                            ))}
                            <LI><H2>+ 255</H2></LI>
                        </UL>
                        <div className="date-lable">
                            <H3 className="float-end">15</H3>
                            <P className="float-end">January</P>
                        </div>
                    </div>
                </div>
            </Row>
        </Col>
    )
}